// Utility for Google OAuth configuration.
// REACT_APP_* variables are embedded at BUILD TIME: if the client ID is
// missing, the frontend must be rebuilt after setting REACT_APP_GOOGLE_CLIENT_ID.

export const getGoogleClientId = () => process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const isGoogleAuthAvailable = () => {
  const clientId = getGoogleClientId();
  return Boolean(clientId && typeof clientId === 'string' && clientId.trim().length >= 10);
};
